/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { GetProducts200ResponseAllOfData } from './GetProducts200ResponseAllOfData';
import {
    GetProducts200ResponseAllOfDataFromJSON,
    GetProducts200ResponseAllOfDataFromJSONTyped,
    GetProducts200ResponseAllOfDataToJSON,
} from './GetProducts200ResponseAllOfData';
import type { ResponseSuccessWithPagingAllOfMeta } from './ResponseSuccessWithPagingAllOfMeta';
import {
    ResponseSuccessWithPagingAllOfMetaFromJSON,
    ResponseSuccessWithPagingAllOfMetaFromJSONTyped,
    ResponseSuccessWithPagingAllOfMetaToJSON,
} from './ResponseSuccessWithPagingAllOfMeta';

/**
 * 
 * @export
 * @interface GetProducts200Response
 */
export interface GetProducts200Response {
    /**
     * 
     * @type {GetProducts200ResponseAllOfData}
     * @memberof GetProducts200Response
     */
    data: GetProducts200ResponseAllOfData;
    /**
     * 
     * @type {ResponseSuccessWithPagingAllOfMeta}
     * @memberof GetProducts200Response
     */
    meta: ResponseSuccessWithPagingAllOfMeta;
}

/**
 * Check if a given object implements the GetProducts200Response interface.
 */
export function instanceOfGetProducts200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function GetProducts200ResponseFromJSON(json: any): GetProducts200Response {
    return GetProducts200ResponseFromJSONTyped(json, false);
}

export function GetProducts200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetProducts200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': GetProducts200ResponseAllOfDataFromJSON(json['data']),
        'meta': ResponseSuccessWithPagingAllOfMetaFromJSON(json['meta']),
    };
}

export function GetProducts200ResponseToJSON(value?: GetProducts200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': GetProducts200ResponseAllOfDataToJSON(value.data),
        'meta': ResponseSuccessWithPagingAllOfMetaToJSON(value.meta),
    };
}

